import { Controller } from "@hotwired/stimulus"

// Polls the extraction run status endpoint and keeps the WORK
// PENDING banner's docs/chunks counters in sync with the live
// extraction card below. Without this the banner is a stale
// server-rendered snapshot; the card updates every 2s and the two
// numbers desync visibly until the admin refreshes.
export default class GsPendingBannerController extends Controller {
  static targets = ["docsWaiting", "chunksWaiting"]
  static values = { url: String }

  connect() {
    if (!this.urlValue) return
    this.poll()
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  poll() {
    fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(data => this.update(data))
      .catch(() => {})
      .finally(() => {
        this._timer = setTimeout(() => this.poll(), 2000)
      })
  }

  update(data) {
    if (!data || data.status === "none") return
    const docsWaiting = Math.max((data.total_docs_pending || 0) - (data.docs_processed || 0), 0)
    const chunksWaiting = Math.max((data.total_chunks || 0) - (data.chunks_processed || 0), 0)
    if (this.hasDocsWaitingTarget) this.docsWaitingTarget.textContent = docsWaiting
    if (this.hasChunksWaitingTarget) this.chunksWaitingTarget.textContent = chunksWaiting
  }
}
